import React, { useEffect, useState } from "react";

import axios from "./../../axios";
import "./BankDetails.css";
import BankDetailsModal from "./BankDetailsModal";

export default function BankDetails() {
  const [loading, setLoading] = useState(true);
  const [bankData, setBankData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    accountHolderName: "",
    bankName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
  });

  useEffect(() => {
    axios
      .get("/v1/tutor/bank-details")
      .then((res) => {
        if (res.data.is_success) {
          setBankData(res.data.data);
          setLoading(false);
        } else {
          setLoading(true);
          throw res.data.error;
        }
      })
      .catch((err) => {
        setLoading(true);
        console.error("Error fetching bank details", err);
      });
  }, []);

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    if (formData.accountNumber !== formData.confirmAccountNumber) {
      alert("Account numbers do not match");
      return;
    }

    if (
      !formData.accountHolderName ||
      !formData.accountNumber ||
      !formData.confirmAccountNumber ||
      !formData.ifscCode
    ) {
      alert("Invalid bank details");
      return;
    }

    setLoading(true);

    axios
      .post("/v1/tutor/bank-details", formData)
      .then((res) => {
        if (res.data.is_success) {
          setBankData(res.data.data);
          setShowForm(false);
          setLoading(false);
          setShowSuccessModal(true);
        } else {
          setLoading(false);
          throw res.data.error;
        }
      })
      .catch((err) => {
        alert("Failed to save bank details");
        console.error(err);
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setShowForm(false);
    setFormData({
      accountHolderName: "",
      bankName: "",
      accountNumber: "",
      confirmAccountNumber: "",
      ifscCode: "",
    });
  };

  const handleEditClick = () => {
    setFormData({
      accountHolderName: bankData.accountHolderName || "",
      bankName: bankData.bankName || "",
      accountNumber: bankData.accountNumber || "",
      confirmAccountNumber: bankData.accountNumber || "",
      ifscCode: bankData.ifscCode || "",
    });
    setShowForm(true);
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <div className="loading">
          <img src="./book-loader.gif" alt=" Loading . . .  " />
        </div>
      </div>
    );
  }

  return (
    <div className="personal-info--container">
      <div className="bank-details-container">
        {!bankData && !showForm && (
          <div className="add-bank-details-center-wrapper">
            <p className="add-bank-details-text">Provide your bank account details to receive payments securely.</p>
            <button className="add-bank-details-btn" onClick={() => setShowForm(true)}>
              Add Your Bank Details
            </button>
          </div>
        )}

        {bankData && !showForm && (
          <div className="bank-details-card">
            <div className="bank-details-header">
              <span className="bank-details-title">Your Bank Details</span>
              <button className="edit-btn" onClick={handleEditClick}>
                Edit ✏️
              </button>
            </div>
            <div>
              <div className="bank-details-key">
                Account Holder Name: <span className="bank-details-value">{bankData.accountHolderName}</span>
              </div>
            </div>
            <p>
              <div className="bank-details-key">
                Bank Name:
                <span className="bank-details-value">{bankData.bankName}</span>
              </div>
            </p>
            <p>
              <div className="bank-details-key">
                Account Number:
                <span className="bank-details-value">XXXXXX{bankData.accountNumber?.slice(-4)}</span>
              </div>
            </p>
            <p>
              <div className="bank-details-key">
                IFSC Code:
                <span className="bank-details-value">{bankData.ifscCode}</span>
              </div>
            </p>
          </div>
        )}

        {showForm && (
          <div className="bank-details-form">
            <div className="bank-details-grid">
              <div className="bank-details-field">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  name="accountHolderName"
                  placeholder="Enter your full name as per bank records"
                  value={formData.accountHolderName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="bank-details-field">
                <label>Bank Name</label>
                <input
                  type="text"
                  name="bankName"
                  placeholder="Enter the bank name"
                  value={formData.bankName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="bank-details-field">
                <label>Account Number</label>
                <input
                  type="text"
                  name="accountNumber"
                  placeholder="Enter your account number"
                  value={formData.accountNumber}
                  onChange={handleInputChange}
                />
              </div>
              <div className="bank-details-field">
                <label>Confirm Account Number</label>
                <input
                  type="text"
                  name="confirmAccountNumber"
                  placeholder="Re-enter your account number"
                  value={formData.confirmAccountNumber}
                  onChange={handleInputChange}
                />
              </div>
              <div className="bank-details-field full-width">
                <label>IFSC Code</label>
                <input
                  type="text"
                  name="ifscCode"
                  placeholder="Enter the IFSC code"
                  value={formData.ifscCode}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="bank-details-security-note">
              <strong>100% Secure 🔒</strong>
              <p>
                Your bank account details will only be used to process payments. HomeShiksha ensures the security and
                privacy of your information.
              </p>
            </div>

            <div className="bank-details-actions-centered">
              <button className="bank-btn-cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button className="bank-btn-save" onClick={handleSubmit}>
                Save
              </button>
            </div>
          </div>
        )}
      </div>

      <BankDetailsModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      />
    </div>
  );
}
